import PropTypes from 'prop-types';

import { detectErrorByCode } from '#client/components/MoveMoney/utils/common';
import useFormStep from '#client/hooks/useFormStep';

import ErrorForm from './ErrorForm';
import SuccessForm from './SuccessForm';

import { INSTANT_DEPOSIT_ERROR_CODES, INSTANT_TRANSFER_STATUS } from '../constants/instants';

const getErrorDetails = (reason) => {
  let errorSubTitle = 'Deposit Error';
  let errorDetail = 'There was an error processing your deposit. Please try another card.';
  const isInsufficientFunds = detectErrorByCode({
    error: reason,
    code: INSTANT_DEPOSIT_ERROR_CODES.INSUFFICIENT_FUNDS
  });

  if (isInsufficientFunds) {
    errorSubTitle = 'Deposit Issue: Insufficient Funds';
    errorDetail = 'The account you used didn’t have enough funds.';
  }

  return { errorSubTitle, errorDetail };
};

const getSuccessDetails = (status) => {
  let successTitle = 'Deposit is processing';
  let successSubTitle = 'Deposit Pending';
  let successDetail =
    'Processing may take up to 2 hours. You’ll get an email when the funds are available.';

  if (status === INSTANT_TRANSFER_STATUS.PROCESSED) {
    successTitle = 'Deposit is complete';
    successSubTitle = 'Deposit Complete';
    successDetail = 'Success! Your funds are now available.';
  }

  return { successTitle, successSubTitle, successDetail };
};

export default function ConfirmationForm({ handleClose }) {
  const { depositData } = useFormStep();

  const { transferReason, transferStatus, createTransferError } = depositData ?? {};
  const { errorDetail, errorSubTitle } = getErrorDetails(transferReason);
  const { successDetail, successSubTitle, successTitle } = getSuccessDetails(transferStatus);

  /**
   * We will show the error screen when:
   * 1. Creating instant deposit routine failed
   * 2. The instant deposit routine has returned status is failed
   * 3. The instant deposit routine has returned a transferReason
   */
  if (createTransferError || transferReason || transferStatus === INSTANT_TRANSFER_STATUS.FAILED) {
    return (
      <ErrorForm
        errorDetail={errorDetail}
        errorSubTitle={errorSubTitle}
      />
    );
  }

  return (
    <SuccessForm
      handleClose={handleClose}
      title={successTitle}
      transactionSubTitle={successDetail}
      transactionTitle={successSubTitle}
    />
  );
}

ConfirmationForm.propTypes = {
  handleClose: PropTypes.func.isRequired
};
